import React from 'react';

import Confetti from 'react-confetti';

import FooterCheckout from 'src/components/functional/FooterCheckout';
import CheckoutHeader from 'src/components/functional/HeaderCheckout';

import {
  ButtonBackApp,
  ContainerTitleAndIcon,
  IconConcluded,
  ImageBanner,
  MainSection,
  PaymentComponent,
  TextConcluded,
} from './style';

import concludedIconSVG from '../../../../assets/images/subscripiton-checkout-icons/checked-green-icon.svg';
import bannerExpertPNG from '../../../../assets/images/consultant-checkout/banner-expert.png';

export function PaymentConcludedConsultantPlan(): JSX.Element {
  return (
    <PaymentComponent>
      <CheckoutHeader />
      <MainSection>
        <ContainerTitleAndIcon>
          <IconConcluded src={concludedIconSVG} />
          <TextConcluded>Pagamento confirmado!</TextConcluded>
        </ContainerTitleAndIcon>
        <TextConcluded>Obrigado por comprar no Resolva!</TextConcluded>
        <ImageBanner src={bannerExpertPNG} alt="Banner APP da consultora" />
        <ButtonBackApp href={process.env.REACT_APP_CONSULTANT_PACKAGE_BUNDLE}>
          VOLTAR PARA O APP
        </ButtonBackApp>
      </MainSection>
      <FooterCheckout />
      <Confetti numberOfPieces={200} recycle={false} />
    </PaymentComponent>
  );
}
